// extracted by mini-css-extract-plugin
export default {"spinner":"_9323a693"};